import angular from 'angular';

import RwIconComponent from './rw-icon-component';

export default angular
  .module('rw-icon', [])
  .component('rwIcon', new RwIconComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/rw-icon/rw-icon-module.js